import React from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Camera, ShieldAlert, RefreshCw } from "lucide-react";

const detectOS = () => {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (/Android/.test(ua)) return "android";
  if (/Mac/.test(platform)) return "macos";
  if (/Win/.test(platform)) return "windows";
  return "other";
};

const INSTRUCTIONS = {
  ios: 'Toque em "aA" na barra de endereço > Configurações do site > Câmera > Permitir.',
  android: "Toque no cadeado ao lado do endereço > Permissões > Câmera > Permitir.",
  windows:
    "Configurações > Privacidade e segurança > Câmera > ative o acesso e a opção para apps de desktop.",
  macos:
    "Ajustes do Sistema > Privacidade e Segurança > Câmera > marque o navegador e reabra-o.",
  other:
    "Abra as permissões do site no seu navegador e ative o acesso à câmera.",
};

export default function CameraPermissionModal({ open, onConfirm, onCancel, mode = "prompt" }) {
  const os = detectOS();
  const isBlocked = mode === "blocked";
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onCancel && onCancel(); }}>
      <DialogContent className="rounded-sm max-w-md" data-testid="camera-permission-modal">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight flex items-center gap-2">
            {isBlocked ? (
              <>
                <ShieldAlert className="w-5 h-5 text-amber-600" /> Câmera bloqueada
              </>
            ) : (
              <>
                <Camera className="w-5 h-5 text-[#152D4B]" /> Usar a câmera com o teleprompter
              </>
            )}
          </DialogTitle>
          {!isBlocked ? (
            <DialogDescription>
              Para gravar seu VT lendo o texto — com o roteiro e a imagem na mesma tela — esta página precisa de acesso à câmera deste dispositivo. A gravação fica salva no seu aparelho e no painel da edição. Ninguém vê nada além da sua equipe. Você também pode usar o teleprompter normalmente sem a câmera.
            </DialogDescription>
          ) : (
            <DialogDescription>
              A permissão de câmera está desativada neste navegador. O teleprompter continua funcionando — apenas a gravação fica indisponível.
            </DialogDescription>
          )}
        </DialogHeader>

        {isBlocked && (
          <div className="rounded-sm border border-zinc-200 bg-zinc-50 p-3 text-sm text-zinc-700 leading-relaxed">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-zinc-500 mb-1">
              Como liberar
            </div>
            {INSTRUCTIONS[os]}
          </div>
        )}

        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            data-testid="camera-permission-cancel"
            onClick={onCancel}
            className="rounded-sm border-zinc-300 text-zinc-600"
          >
            {isBlocked ? "Fechar" : "Agora não"}
          </Button>
          <Button
            data-testid="camera-permission-confirm"
            onClick={onConfirm}
            className="rounded-sm bg-[#152D4B] hover:bg-[#0E1F36] text-white"
          >
            {isBlocked ? (
              <><RefreshCw className="w-4 h-4 mr-1.5" /> Tentar de novo</>
            ) : (
              <>Permitir câmera</>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
